// #region Imports

import Vue from 'vue';
// io.order Page-Components
import '@/modules/order-pages';
// io.order Modal-Components
import '@/modules/order-modals';
import Mains from '@/order/layout/Main.vue';

// #endregion

// #region Component Registration

// eslint-disable-next-line vue/multi-word-component-names
Vue.component('Mains', Mains);

Vue.component('OrderCreateLeadModal', () => import(/* webpackChunkName: "order-components" */ '../order/components/create/OrderCreateLeadModal.vue'));
Vue.component('TariffPriceChange', () => import(/* webpackChunkName: "order-components" */ '../order/components/create/TariffPriceChange.vue'));
Vue.component('OrderBlacklistModalCreate', () => import(/* webpackChunkName: "order-components" */ '@/apps/order/components/OrderBlacklistModalCreate.vue'));

Vue.component('OrderPartnerUserInvite', () => import(/* webpackChunkName: "order-partner-components" */ '../order/components/partner/OrderPartnerUserInvite.vue'));
Vue.component('OrderPartnerTeamCreate', () => import(/* webpackChunkName: "order-partner-components" */ '../order/components/partner/OrderPartnerTeamCreate.vue'));
Vue.component('OrderPartnerProfileTeamsModal', () => import(/* webpackChunkName: "order-partner-components" */ '../order/components/partner/OrderPartnerProfileTeamsModal.vue'));
Vue.component('PartnerOrderCommentsModal', () => import(/* webpackChunkName: "order-partner-components" */ '../order/components/partner/PartnerOrderCommentsModal.vue'));
Vue.component('PartnerOrderMailsModal', () => import(/* webpackChunkName: "order-partner-components" */ '../order/components/partner/PartnerOrderMailsModal.vue'));
Vue.component('PartnerOrderMediaModal', () => import(/* webpackChunkName: "order-partner-components" */ '../order/components/partner/PartnerOrderMediaModal.vue'));

// #endregion
